<script setup lang="ts">
import type { AppBadgeSchema } from '~/types/product.model'

const props = defineProps<{
  badge: AppBadgeSchema
}>()

const icons: Record<string, string> = {
  sendcloud: 'fa6-solid:shield-halved',
  staff: 'fa-solid:heart',
  popular: 'fa-solid:star',
}

const icon = computed(() => icons[props.badge.icon || ''] || '')
</script>

<template>
  <span
    :class="['app-badge', `app-badge__${badge.icon || ''}`]"
    data-test="app-badge"
  >
    <Icon
      v-if="icon"
      :name="icon"
      data-test="app-badge-icon"
    />
    <span
      data-test="app-badge-name"
      class="app-badge__name"
    >
      {{ badge.title }}
    </span>
  </span>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/helpers' as *;

.app-badge {
  @extend %font-16-21-regular-adaptive-12-18;

  border: 1px solid gray;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  gap: var(--app-spacer-4);
  padding: var(--app-spacer-6);
}

.app-badge__name {
  text-wrap: nowrap;
}

.app-badge__sendcloud {
  border-color: var(--app-badge-sendcloud);
}

.app-badge__staff {
  border-color: var(--app-badge-staff);
}

.app-badge__popular {
  border-color: var(--app-badge-popular);
}
</style>
